<app-cobrowse-session
  [interaction]="interaction"
  (destroyed)="cobrowseEnded()"
  (sketchReady)="sketchConnected($event)"
  [class.cobrowse-session-talkdesk]="isTalkdeskApp"
>
</app-cobrowse-session>
